// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__qvVjJ","bounce":"Modal_bounce__T73Kz","overlay":"Modal_overlay__+k5zY","Wrapper":"Modal_Wrapper__JENCO"};